import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Box, Alert, Chip } from '@mui/material';
import PaymentIcon from '@mui/icons-material/Payment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

// Payment Status Component for Session Details
const SessionPaymentStatus = ({ session }) => {
  const hasPaymentRequired = session.ChargerSessionCost && session.ChargerSessionCost > 0;
  const isCompleted = session.ChargerSessionEnd;
  const paymentStatus = session.ChargerSessionPaymentStatus?.toLowerCase();
  const isPaid = ['paid', 'completed', 'succeeded', 'success'].includes(paymentStatus);
  
  // Function to get chip color based on payment status
  const getPaymentStatusColor = (status) => {
    if (['paid', 'completed', 'succeeded', 'success'].includes(status)) {
      return 'success';
    } else if (['failed', 'cancelled', 'error'].includes(status)) {
      return 'error';
    } else {
      return 'warning';
    }
  };

  if (!hasPaymentRequired) {
    return (
      <Alert severity="info" sx={{ mb: 2 }}>
        No payment required for this session
      </Alert>
    );
  }

  if (isPaid) {
    return (
      <Alert severity="success" icon={<CheckCircleIcon />} sx={{ mb: 2 }}>
        Payment completed for this session
      </Alert>
    );
  }

  if (!isCompleted) {
    return (
      <Alert severity="warning" sx={{ mb: 2 }}>
        Session is still active. Payment will be available after session completion.
      </Alert>
    );
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Alert severity="warning" sx={{ mb: 2 }}>
        Payment required: ${session.ChargerSessionCost.toFixed(2)}
        {paymentStatus && (
          <Box sx={{ mt: 1 }}>
            Payment Status: <Chip label={paymentStatus} color={getPaymentStatusColor(paymentStatus)} size="small" />
          </Box>
        )}
      </Alert>
      
      <Button
        component={Link}
        to={`/sessions/${session.ChargeSessionId}/payment`}
        variant="contained"
        color="success"
        size="large"
        startIcon={<PaymentIcon />}
        fullWidth
        sx={{ py: 1.5 }}
      >
        Pay ${session.ChargerSessionCost.toFixed(2)}
      </Button>
    </Box>
  );
};

export default SessionPaymentStatus;
